module.exports = __webpack_public_path__ + "static/media/student12.64044de5.png";